export interface ScoreCardModel {
  starRating: number;
  sections: Section[];
  message?: string;
  timeStamp?: string;
  timestamp?: string;
}

interface Section {
  componentType: string;
  color: string;
  components: Component[];
  totalComponentScore: number;
}

interface Component {
  identifier: string;
  name: string;
  weightage: string;
  accessLevel: string;
  wards?: Ward[];
  marks: number;
  qualifiedForLevel: string;
  score: number;
  isQualified: boolean;
  questions?: Question[];
}

interface Ward {
  wardNumber: number;
  level: string;
  score: number;
  questions: Question[];
  areas?: any[];
  qualified: boolean;
}

interface Question {
  identifier: string;
  description: string;
  answer: string;
  questions?: Question[]
}

export enum GfcStatus {
  APP_STARTED = 'APP_STARTED',
  DRAFT_SAVE = 'DRAFT_SAVE',
  APP_SUBMITTED = 'APP_SUBMITTED',
  ASSIGN_TO_DA = 'ASSIGN_TO_DA',
  DA_IN_PROGRESS = 'DA_IN_PROGRESS',
  RE_SUBMIT = 'RE_SUBMIT',
  DA_QUERY = 'DA_QUERY',
  DA_PASS = 'DA_PASS',
  DA_FAIL = 'DA_FAIL',
  RE_APPLY = 'RE_APPLY',
  ULB_REPLIED = 'ULB_REPLIED',
  DA_APPROVED_FOR_FA = 'DA_APPROVED_FOR_FA',
  RESULT_DECLARED = 'RESULT_DECLARED'
}

export enum odfStatus {
  APP_STARTED = 'APP_STARTED',
  DRAFT_SAVE = 'DRAFT_SAVE',
  APP_SUBMITTED = 'APP_SUBMITTED',
  ASSIGN_TO_DA = 'ASSIGN_TO_DA',
  DA_IN_PROGRESS = 'DA_IN_PROGRESS',
  RE_SUBMIT = 'RE_SUBMIT',
  DA_QUERY = 'DA_QUERY',
  DA_PASS = 'DA_COMPLETE',
  DA_INCOMPLETE = 'DA_INCOMPLETE',
  RE_APPLY = 'RE_APPLY',
  ULB_REPLIED = 'ULB_REPLIED',
  DA_APPROVED_FOR_FA = 'DA_APPROVED_FOR_FA',
  // RESULT_DECLARED = 'RESULT_DECLARED'
}

export enum GfcStep {
  SCORECARD = 'scorecard',
  CITY_EVIDENCE = 'city-evidences',
  WARD_EVIDENCE = 'ward-evidences',
  DECLARATIONS = 'upload-declarations',
  PREVIEW = 'preview'
}
